// extracted by mini-css-extract-plugin
export default {"container":"UZ-z","heading":"VZ-z","links":"WZ-z","copy":"XZ-z","subCopy":"YZ-z","linksLeft":"ZZ-z","linksCenter":"_Z-z","linksRight":"a0-z","link":"b0-z","onlyLink":"c0-z"};